import { type FC, type ReactNode } from 'react';

import * as styles from './styles.css';

interface IAdfoxCarouselWrapperProps {
  children: ReactNode;
}

export const AdfoxCarouselWrapper: FC<IAdfoxCarouselWrapperProps> = ({ children }) => (
  <div className={styles['container']} data-testid="adfox_carousel">
    {children}
  </div>
);
